import React from "react";
import styles from "./TextView.module.scss";
import { ElementType } from "../../../shared/types";
const TextView = ({
  element,
  text,
  minWidth,
  elementContentRef
}) => {
  const values = element?.settings;
  const buttonSettings = element?.settings;
  const textId = element?.type === ElementType.Button ? buttonSettings?.design?.textId : values?.textId;
  return /*#__PURE__*/React.createElement("div", {
    ref: elementContentRef,
    id: element?.id,
    "data-test": "TextView",
    className: styles.text,
    style: {
      width: "fit-content",
      minWidth
    },
    dangerouslySetInnerHTML: {
      __html: text?.[textId] || ""
    }
  });
};
export { TextView };
//# sourceMappingURL=TextView.js.map